import {
  ButtonGroup,
  IconButton,
  SkeletonText,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import iconArrowLeftRight from "assets/icons/icon-arrow-left-right.svg";
import IconEye from "assets/icons/icon-eye.svg?react";
import EmptyList from "components/ui/EmptyList";
import IconButtonEdit from "components/ui/IconButtonEdit";
import { Link, useLocation } from "react-router-dom";

import { flexRender } from "@tanstack/react-table";
import ButtonRemoveResource from "components/ButtonRemoveResource";
import Pagination from "components/ui/Pagination";
import { useServerDynamicTableContext } from "contexts/server-table/ServerDynamicTableContext";

export default function AgendaList() {
  const location = useLocation();
  const { table, queryResult } = useServerDynamicTableContext();
  const total = queryResult?.data?.meta?.total || 0;
  const isLoading = queryResult?.isLoading || false;

  const hasData = total > 0;
  const hasResult = table.getRowModel().rows.length > 0;

  return (
    <SkeletonText isLoaded={!isLoading}>
      {hasResult && (
        <>
          <Table mt="25px">
            <Thead>
              <Tr>
                <Th>Modelo</Th>
                <Th>Assunto</Th>
                <Th>Período</Th>
                <Th w="100px">Status</Th>
                <Th w="100px">Destinatários</Th>
                <Th w="100px">Enviados</Th>
                <Th w="100px">Bounce</Th>
                <Th w="100px">Criado em</Th>
                <Th w="100px">Enviado em</Th>
                <Th w="100px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {table.getRowModel().rows.map((row) => (
                <Tr key={`row-${row.id}`}>
                  {row.getVisibleCells().map((cell) => (
                    <Td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Td>
                  ))}
                  <Td>
                    <ButtonGroup>
                      <IconButton
                        aria-label="Visualizar"
                        size="sm"
                        icon={<IconEye />}
                        as={Link}
                        to={{
                          pathname: `/disparos-de-agenda/${String((row.original as Record<string, unknown>).id)}`,
                          search: location.search,
                        }}
                      />
                      {!(row.original as Record<string, unknown>).email && (
                        <>
                          <IconButtonEdit
                            to={{
                              pathname: `/disparos-de-agenda/editar/${String((row.original as Record<string, unknown>).id)}`,
                              search: location.search,
                            }}
                          />
                          <ButtonRemoveResource
                            id={String((row.original as Record<string, unknown>).id)}
                            pathName="agendas"
                            queryKey="agendas"
                          />
                        </>
                      )}
                    </ButtonGroup>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>

          <Pagination table={table} />
        </>
      )}
      {(!hasData || !hasResult) && (
        <EmptyList
          mt="25px"
          icon={iconArrowLeftRight}
          title={
            !hasData
              ? "Você ainda não possui nenhum disparo de Agenda cadastrado"
              : "Nenhum resultado encontrado"
          }
          description={hasData ? "" : "Use o botão acima para cadastrar"}
          isTable
        />
      )}
    </SkeletonText>
  );
}
